import AuspicienteModel from "../../domain/models/auspiciante.model";
import BaseApi from "../api/base.api";

class SponsorService {
    private baseApi: BaseApi;

    private uriSponsor: string;

    constructor() {
        this.baseApi = new BaseApi();
        this.uriSponsor = 'catalogo/auspiciante';
    }

    public getAllSponsors = async (): Promise<AuspicienteModel[]> => {
        const response = await this.baseApi.apliClient.get<AuspicienteModel[]>(this.uriSponsor);
        return response.data;
    }

    public createSponsor = async (sponsor: AuspicienteModel): Promise<AuspicienteModel> => {
        const response = await this.baseApi.apliClient.post<AuspicienteModel>(this.uriSponsor, sponsor);
        return response.data;
    }

    public updateSponsor = async (sponsor: AuspicienteModel): Promise<AuspicienteModel> => {
        const response = await this.baseApi.apliClient.put<AuspicienteModel>(`${this.uriSponsor}/${sponsor.id}`, sponsor);
        return response.data;
    }

    public deleteSponsor = async (id: number): Promise<void> => {
        await this.baseApi.apliClient.delete(`${this.uriSponsor}/${id}`);
    }
}

export default SponsorService;